import Store, { persistor } from './rootReducer';

export { persistor };

export default Store;
